<template>
    <Loading v-bind:show="showLoadingAtivos" v-if="$featureToggle && $featureToggle.INTEGRA_MENSALIDADES_ATIVOS">
        <PageTitle title="Mensalidades - Ativos" />
        <md-toolbar id="md-toolbar-page" md-elevation="0" class="md-dense" style="background-color: inherit">
            <h3 class="md-title" style="flex: 1"></h3>
            <md-button class="md-text-and-icon md-outlined md-primary md-dense" @click="modalIncluirMensalidade()">
                <md-icon>playlist_add</md-icon>Incluir
            </md-button>
        </md-toolbar>

        <div style="clear:both"></div>
        <Grid v-if="dadosAba && dadosAba.mensalidades"
              v-bind:Data="dadosAba.mensalidades"
              v-bind:Header="headerAtivas"
              Name="MensalidadesAtivas"
              OrderBy="anoMes"
              v-bind:HeaderDetalhes="null"
              v-bind:DetalhesCombo1="dadosAba.periodo"
              v-bind:DetalhesCombo2="dadosAba.situacao"
              v-bind:DetalhesCombo3="null" />

        <md-dialog :md-active.sync="incluirMensalidade" class="md-layout-item md-size-30 zindex">
            <div class="padding-20">

                <h3 class="divLeft200">Incluir Mensalidade</h3>
                <md-dialog-actions class="divRight">
                    <md-button class="md-primary" @click="incluirMensalidade = false; ">Fechar</md-button>
                </md-dialog-actions>
                <div style="clear:both"></div>
                <h4>{{aluno.nomeAluno}}</h4>
                <div style="clear:both"></div>

                <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                        <md-field>
                            <label for="combo1" class="color6361FB">Ano/Mês</label>
                            <md-input name="txtAnoMes" id="txtAnoMes" v-model="anoMes" maxlength="7" v-mask="['##/####', '#/####']" />
                        </md-field>
                    </div>
                </div>
                <button class="buttonIncluirMensalidade" v-on:click="gerarMensalidade()">Salvar<md-icon class="iconeIncluirMensalidade">done</md-icon></button>
            </div>
        </md-dialog>
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Mensalidades from '@/services/MensalidadesService.js';
    import { mask } from 'vue-the-mask'; //https://vuejs-tips.github.io/vue-
  export default {
    components: {
        Grid,
        Loading,
        PageTitle
    },
    directives: {
      mask
    },
    created() {
      this.mensalidadesService = new Mensalidades(this);

      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {
        let a = JSON.parse(sessionStorage.Aluno);
        //Coloca o perfil de aluno disponível na variável aluno
        if (a.PerfilAluno) {
          this.aluno = a.PerfilAluno;
          //Verifica se os dados da Aba ja esta carregado
          if (a.MensalidadesAtivas) {
            this.dadosAba = a.MensalidadesAtivas;
          }
          else {
            this.dadosAba = this.ativos();
          }
        }
        else
          this.$router.push('home');
      }
    },
    beforeDestroy() {
      let aluno = JSON.parse(sessionStorage.Aluno);

      //Armazena os dados da aba pra nao precisar carregar novamente
      aluno.MensalidadesAtivas = this.dadosAba;
      sessionStorage.setItem("Aluno", JSON.stringify(aluno));
    },
    data() {
      return {
        incluirMensalidade: false,
        aluno: null,
        headerAtivas: [
          {
            Titulo: "Ano/Mês",
            Field: "anoMes",
            Width: "80px",
            Tipo: "texto"
          },
          {
            Titulo: "Dt Vencimento",
            Field: "data_vencimento",
            Width: "40px",
            Tipo: "date"
          },
          {
            Titulo: "Dt Pagamento",
            Field: "data_pagamento",
            Width: "40px",
            Tipo: "date"
          },
          {
            Titulo: "Valor Mensalidade",
            Field: "valor_titulo",
            Width: "80px",
            Tipo: "moeda"
          },
          {
            Titulo: "Desconto",
            Field: "valor_desconto",
            Width: "80px",
            Tipo: "moeda"
          },
          {
            Titulo: "Juros",
            Field: "valor_juros",
            Width: "80px",
            Tipo: "moeda"
          },
          {
            Titulo: "Valor pago",
            Field: "valor_pago",
            Width: "80px",
            Tipo: "moeda"
          }
        ],
        headerDetalheAtivos: [
          {
            Titulo: "Convênio",
            Field: "convenio",
            Tipo: "texto"
          },
          {
            Titulo: "Desconto Pontualidade",
            Field: "valor_desconto",
            Tipo: "moeda"
          },
          {
            Titulo: "Tipo Baixa",
            Field: "tipo_baixa",
            Tipo: "texto"
          },
          {
            Titulo: "Tipo Pagamento",
            Field: "tipo_pagamento",
            Tipo: "texto"
          },
          {
            Titulo: "Transação",
            Field: "transacao",
            Tipo: "numero"
          }
        ],
        dadosAba: null,
        showLoadingAtivos: false,
        anoMes: ""
      }
    },
    methods: {
      modalIncluirMensalidade() {
        this.anoMes = "";
        this.incluirMensalidade = true;
      },

      gerarMensalidade() {
        //if (this.$featureToggle.INTEGRA_MENSALIDADES_GERAR) {

        if (!this.anoMes) {
          this.$modal.alert("É necessário informar a competência para gerar a mensalidade!");
        }
        else {

          // verifica se é um mês válido
          let data = this.anoMes.replace("/", "");
          let mes = 0;

          if (data.length == 5)
            mes = data.substring(0, 1);
          else
            mes = data.substring(0, 2);

          if (Number(mes) < 1 || Number(mes) > 12) {
            this.$modal.alert("É necessário informar um mês válido para gerar a mensalidade do aluno!");
          }
          else {
            this.showLoadingAtivos = true;
            this.mensalidadesService.Gerar({
              CodigoAluno: this.aluno.codigoAluno,
              CodigoEspecialidade: this.aluno.codigoEspecialidade,
              CodigoEmpresa: this.aluno.codigoEmpresa,
              Competencia: this.anoMes
            }).then(
              data => {
                if (data.ok) {
                  this.ativos();
                  this.anoMes = "";
                  this.$modal.info(data.mensagem);
                }
                else
                  this.$modal.info(data.mensagem);
              },
              error => {
                this.$modal.error((error.body?.Mensagem || 'Ocorreu um erro ao gerar a mensalidade para o aluno.'), (error.body?.Detalhe || error?.response?.statusText || error.message));
              }).finally(() => {
                this.showLoadingAtivos = false;
              });
            //}
            //else {
            //    this.$modal.alert(this.$msgFeatureToggle);
            //}
          }
        }
      },

      ativos() {
        if (this.$featureToggle.INTEGRA_MENSALIDADES_ATIVOS) {
          this.showLoadingAtivos = true;
          this.mensalidadesService.ListarMensalidadesAlunoAtivas({
            CodigoAluno: this.aluno.codigoAluno,
            CodigoEspecialidade: this.aluno.codigoEspecialidade,
            Pagina: 1,
            ItensPagina: 100
          }).then(
            data => {
              if (data.ok) {
                this.dadosAba = data.dados;
              }
              else {
                this.$modal.alert(data.mensagem);
              }
            },
            error => {
              this.$modal.error((error.body?.Mensagem || 'Ocorreu um erro ao tentar buscar os dados.'), (error.body?.Detalhe || error?.response?.statusText || error.message));
            }).finally(() => {
              this.showLoadingAtivos = false;
            });
        }
        else {
          this.$modal.alert(this.$msgFeatureToggle);
        }
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-field {
    max-width: 100%;
    font-weight: bold;
  }

  .md-tab {
    padding: 0;
    margin: 0 !important;
  }

  .divLeft200 {
    width: 200px;
    float: left;
    position: relative;
    display: inline;
  }

  .padding-20 {
    padding: 0 20px 10px 20px;
  }

  .filtro {
    height: 40px !important;
    font-size: 20px !important;
  }

  .color6361FB {
    color: #6361FB !important;
  }

  .option {
    background-color: #fff !important;
  }

    .option:hover {
      background-color: #6361FB !important;
    }

  .webkit-text-fill-color6361FB {
    -webkit-text-fill-color: #6361FB !important;
  }

  .border6361FB {
    border-bottom-color: #6361FB !important;
  }
</style>
